import {Injectable} from '@angular/core';
import {SessionService} from "./session.service";
import {AlertPopupService} from "./alert-popup.service";
import {Router} from "@angular/router";
import {IAddress} from "../interfaces/Iaddress";

const GENERIC_ERROR_MSG = 'Something went wrong, please try after sometime.';

@Injectable({
	providedIn: 'root'
})
export class Helper {
	constructor(
		private sessionService: SessionService,
		private alertPopupService: AlertPopupService,
		private router: Router,
	) {
	}

	IsMobile$ () : boolean {
		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			return true
		} else {
			return false
		}
	}

	RemoveEmptyKeys$ (payload : any) : Object {
		Object.keys(payload).forEach((key) => {
			if (!payload[key]) {
				delete payload[key];
			}
		});
		return payload;
	}

	RemoveDuplicatesFromFilterCriteria$ (oldFilterCriteria : any[], newCriteria) {
		let updatedFilterCriteria:any = [];

		oldFilterCriteria.forEach(filter => {
			if (newCriteria[filter.field] === undefined) {
				updatedFilterCriteria.push(filter);
			}
		});

		return updatedFilterCriteria;
	}

	CreateFilterPayloadForReq$ (criteria: any) : any {
		return Object.keys(criteria).map(item => {
			let res:any = {
				field: item,
				relation: 'eq',
				thresh: criteria[item],
			}

			if(criteria[item] === 'GOLD'){
				res = {
					field: item,
					relation: 'in',
					thresh: ['GOLD_22','GOLD_24','GOLD_18'],
				}
			}

			if (Array.isArray(criteria[item])) {
				res = {
					...res,
					relation: 'in'
				}
			}

			if (['price'].includes(item)) {
				res = {
					...res,
					relation: 'lt'
				}
			}

			if (['name'].includes(item)) {
				res = {
					...res,
					relation: 'has'
				}
			}

			// if (['variant.primaryMetal.purity'].includes(item)) {
			// 	res = {
			// 		...res,
			// 		type: 'arr'
			// 	}
			// }

			if (['variant.diamond.count'].includes(item)) {
				res = {
					...res,
					relation: 'gt',
					type: 'arr'
				}
			}

			return res;
		});
	}

	CreateSortPayloadForReq$ (criteria: any) : any {
		let obj = {};

		Object.keys(criteria).forEach(item => {
			obj['field'] = item;
			obj['order'] = criteria[item];
		});

		return obj;
	}

	FormatAddress$( address : IAddress, limitAddress = false) {
		if (address) {
			let addressString = `${address.addressLine1}, `;
			addressString += address.addressLine2 ? `${address.addressLine2}, ` : '';

			if (limitAddress) {
				return `${addressString}${address.city}`.substring(0, 30) + '...';
			} else {
				return `${addressString}${address.city}, ${address.state}`;
			}
		} else {
			return '';
		}
	}

	Error$ = (payload, message = '') => {
		console.error(payload)
		if (payload.status === 401) {
			this.sessionService.unsetState();
			this.router.navigate(['/'])
		}

		this.alertPopupService.showErrorAlert(
			message
				? message
				: (
					(payload.error?.error?.message)
						? payload.error.error.message
						: GENERIC_ERROR_MSG
				)
		);
	}
}
